import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-home-solid",
  "use": "icon-home-solid-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" id=\"icon-home-solid\"><path d=\"M8 1 1 9h2.5v5H7v-4c0-.6.5-1 1-1 .6 0 1 .4 1 1v4h3.5V9H15z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol